export default __webpack_public_path__ + "static/media/localtext.ecb35b47.csv";